import React, { useEffect } from 'react';
import { Col, Row } from 'react-flexbox-grid';
import {
	Breadcrumb,
	BreadcrumbHome,
	BreadcrumbItem,
	Button,
	Module,
	ModuleBody,
	ModuleHeader,
	SecondaryNavigation,
	SecondaryNavigationTitle,
	Wrapper,
} from '@wfp/ui';
import { iconAddGlyph, iconChevronLeft, iconChevronRight } from '@wfp/icons';

import { useCalendarRangeStart, useEWUser } from '../../hooks/home';
import { userCanEditWarnings } from '../../restapi/warning';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { formatDateShort } from '../../utils/utils';
import { WarningTable } from './WarningTable';
import { addMonths, firstDayOfMonth, previousDay, simplyToday } from '../../utils/SimpleDate';

import { setDataForNewEvent } from '../event/PageEvent';
import { setHomepageUrl } from '../../utils/navigation';
import { PeriodPicker } from './PeriodPicker';

import "./PageHome.scss";


export function PageHome() {
	const user = useEWUser();
	const from = useCalendarRangeStart();
	const to = previousDay(addMonths(from, 6));

	const location = useLocation();
	useEffect(() => {
		setHomepageUrl(location.pathname);
	}, [location]);

	const navigate = useNavigate();
	const newWarning = () => {
		// TODO if current month is outside range [from, to] we need a better default (like "from + 2 months")
		setDataForNewEvent(firstDayOfMonth(simplyToday()));
		navigate(`/event/0`);
	}

	if (!user) {
		return null;
	}
	const canEditWarning = userCanEditWarnings(user);

	return (<div>
		<SecondaryNavigation>
			<Breadcrumb>
				<BreadcrumbItem>
					<Link to="/">
						<BreadcrumbHome/>
					</Link>
				</BreadcrumbItem>
				<BreadcrumbItem disableLink> Homepage</BreadcrumbItem>
			</Breadcrumb>

			<SecondaryNavigationTitle>
				Early Warning Watch List
			</SecondaryNavigationTitle>
		</SecondaryNavigation>

		<Wrapper className="main-wrapper" background="lighter" pageWidth="lg" spacing="md">
			<Module>
				<ModuleHeader>
					<Row between="xs" middle="xs">
						<Col xs className="title">
							<h1 className="wfp--module__title">All warnings</h1>
						</Col>
						<Col xs className="title">
							<div className="wfp--module__title">
								<Link to={`/${addMonths(from, -3)}`} role="navigation" aria-label="Previous trimester">
									<Button icon={iconChevronLeft} kind="ghost" iconDescription="Previous trimester"/>
								</Link>
								<PeriodPicker key={from} selectedDate={from}>
									<span data-testid="trimester">
										{formatDateShort(from)} &mdash; {formatDateShort(to)}
									</span>
								</PeriodPicker>
								<Link to={`/${addMonths(from, +3)}`} role="navigation" aria-label="Next trimester">
									<Button icon={iconChevronRight} kind="ghost" iconDescription="Next trimester"/>
								</Link>
							</div>
						</Col>
						<Col xs className="col-fit-content">
							<Button kind="primary"
									icon={iconAddGlyph} iconDescription="Add" iconReverse
									disabled={!canEditWarning}
									onClick={newWarning}>
								New warning
							</Button>
						</Col>
					</Row>
				</ModuleHeader>
				<ModuleBody>
					<p className="note">Editions: click on a month in the column header to preview
						a <strong>Monthly Report</strong> document draft or
						an <strong>Active warnings</strong> table.</p>
					<p className="note mb">Timeline: click on a warning name to review
						its full <strong>timeline</strong>.</p>

					<WarningTable/>

				</ModuleBody>
			</Module>
		</Wrapper>
	</div>);
}